var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (sd, services, stitch, user) {
jade_mixins["settings-section"] = jade_interp = function(id, name, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div" + (jade.attr("id", id, true, true)) + (jade.attr("data-id", id, true, true)) + (jade.attr("data-name", label || name, true, true)) + " class=\"settings-section js-settings-section\"><h2 class=\"settings-section__name\">" + (jade.escape(null == (jade_interp = name) ? "" : jade_interp)) + "</h2><div" + (jade.cls(['settings-section__main','js-settings-section__main--' + (id) + ''], [null,true])) + "><div" + (jade.cls(['settings-' + (id) + ''], [true])) + ">");
block && block();
buf.push("</div></div></div>");
};
jade_mixins["settings-section"].call({
block: function(){
buf.push("<div id=\"stitch-user-information\">" + (null == (jade_interp = stitch.components.UserInformation({ mountId: 'stitch-user-information' })) ? "" : jade_interp) + "</div>");
}
}, 'information', '');
jade_mixins["settings-section"].call({
block: function(){
buf.push("<div class=\"stacked-form js-settings-password--toggleable\"><label class=\"avant-garde-form-label\">Current Password</label><input name=\"decoy-password\" type=\"password\" value=\"●●●●●●●\" disabled class=\"bordered-input\"><hr class=\"is-invisible\"><a class=\"avant-garde-button-white js-settings-password__toggle\">Create New Password</a></div><form class=\"settings-password__form stacked-form js-settings-password--toggleable\"><div class=\"form-errors js-form-errors\"></div><label for=\"current-password\" class=\"avant-garde-form-label\">Current Password</label><input id=\"current-password\" name=\"current_password\" type=\"password\" autocomplete=\"on\" pattern=\".{6,}\" title=\"6 characters minimum\" autofocus required class=\"bordered-input\"><label for=\"new_password\" class=\"avant-garde-form-label\">New Password</label><input id=\"new_password\" name=\"new_password\" type=\"password\" autocomplete=\"on\" pattern=\".{6,}\" title=\"6 characters minimum\" required class=\"bordered-input\"><label for=\"password_confirmation\" class=\"avant-garde-form-label\">Repeat New Password</label><input id=\"password_confirmation\" name=\"password_confirmation\" type=\"password\" autocomplete=\"on\" pattern=\".{6,}\" title=\"6 characters minimum\" required class=\"bordered-input\"><button class=\"avant-garde-button-black\">Save Changes</button><a class=\"avant-garde-button-white js-settings-password__toggle\">Cancel</a></form>");
}
}, 'password', 'Password');
jade_mixins["settings-section"].call({
block: function(){
buf.push("<div id=\"stitch-two-factor-authentication\">" + (null == (jade_interp = stitch.components.TwoFactorAuthentication({ mountId: 'stitch-two-factor-authentication' })) ? "" : jade_interp) + "</div>");
}
}, 'two-factor-authentication', '');
jade_mixins["settings-section"].call({
block: function(){
jade_mixins["providerIcon"] = jade_interp = function(provider){
var block = (this && this.block), attributes = (this && this.attributes) || {};
switch (provider ){
case 'apple':
buf.push("<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path d=\"M24.734 17.003c-0.040-4.053 3.305-5.996 3.454-6.093-1.88-2.751-4.808-3.127-5.851-3.171-2.492-0.252-4.862 1.467-6.127 1.467-1.261 0-3.213-1.43-5.28-1.392-2.716 0.040-5.221 1.579-6.619 4.012-2.822 4.897-0.723 12.151 2.028 16.123 1.344 1.944 2.947 4.127 5.051 4.049 2.026-0.081 2.793-1.311 5.242-1.311s3.138 1.311 5.283 1.271c2.18-0.041 3.562-1.981 4.897-3.931 1.543-2.255 2.179-4.439 2.216-4.551-0.048-0.022-4.252-1.632-4.294-6.473zM20.705 5.11c1.117-1.355 1.871-3.235 1.665-5.11-1.609 0.066-3.559 1.072-4.713 2.423-1.036 1.199-1.942 3.113-1.699 4.951 1.796 0.14 3.629-0.913 4.747-2.264z\"></path></svg>");
  break;
case 'facebook':
buf.push("<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path d=\"M29 0h-26c-1.65 0-3 1.35-3 3v26c0 1.65 1.35 3 3 3h13v-14h-4v-4h4v-2c0-3.306 2.694-6 6-6h4v4h-4c-1.1 0-2 0.9-2 2v2h6l-1 4h-5v14h9c1.65 0 3-1.35 3-3v-26c0-1.65-1.35-3-3-3z\"></path></svg>");
  break;
}
};
buf.push("<div class=\"form-errors js-form-errors\">");
if ( sd.ERROR)
{
buf.push(null == (jade_interp = sd.ERROR) ? "" : jade_interp);
}
buf.push("</div>");
if ( sd.ENABLE_SIGN_IN_WITH_APPLE)
{
services = ['Facebook', 'Apple']
}
else
{
services = ['Facebook']
}
// iterate services
;(function(){
  var $$obj = services;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var service = $$obj[$index];

buf.push("<div class=\"settings-linked-accounts__service settings-split\"><div class=\"settings-split__left\"><div class=\"settings-linked-accounts__service__name\">" + (jade.escape(null == (jade_interp = service) ? "" : jade_interp)) + "</div></div><div class=\"settings-split__right\"><a" + (jade.attr("href", sd.AP[service.toLowerCase() + 'Path'], true, true)) + (jade.attr("data-service", service.toLowerCase(), true, true)) + (jade.attr("data-connected", user.isLinkedTo(service.toLowerCase()) ? 'connected' : 'disconnected', true, true)) + " class=\"settings-linked-accounts__service__toggle avant-garde-button-white js-settings-linked-accounts__service__toggle\"><i" + (jade.attr("id", "" + ((service.toLowerCase())) + "-svg-icon", true, true)) + ">");
jade_mixins["providerIcon"](service.toLowerCase());
buf.push("</i></a></div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var service = $$obj[$index];

buf.push("<div class=\"settings-linked-accounts__service settings-split\"><div class=\"settings-split__left\"><div class=\"settings-linked-accounts__service__name\">" + (jade.escape(null == (jade_interp = service) ? "" : jade_interp)) + "</div></div><div class=\"settings-split__right\"><a" + (jade.attr("href", sd.AP[service.toLowerCase() + 'Path'], true, true)) + (jade.attr("data-service", service.toLowerCase(), true, true)) + (jade.attr("data-connected", user.isLinkedTo(service.toLowerCase()) ? 'connected' : 'disconnected', true, true)) + " class=\"settings-linked-accounts__service__toggle avant-garde-button-white js-settings-linked-accounts__service__toggle\"><i" + (jade.attr("id", "" + ((service.toLowerCase())) + "-svg-icon", true, true)) + ">");
jade_mixins["providerIcon"](service.toLowerCase());
buf.push("</i></a></div></div>");
    }

  }
}).call(this);

}
}, 'linked-accounts', 'Linked Accounts');
jade_mixins["settings-section"].call({
block: function(){
jade_mixins["checkbox"] = jade_interp = function(name, disabled){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"settings-split artsy-checkbox\"><div class=\"settings-split__left\"><label" + (jade.attr("for", name, true, true)) + " class=\"artsy-checkbox--label js-settings-checkbox-label\">");
block && block();
buf.push("</label></div><div class=\"settings-split__right\"><div class=\"artsy-checkbox--checkbox\"><input type=\"checkbox\"" + (jade.attr("id", name, true, true)) + (jade.attr("name", name, true, true)) + (jade.attr("checked", user && user.isChecked(name), true, true)) + (jade.attr("disabled", disabled, true, true)) + "><label" + (jade.attr("for", name, true, true)) + "></label></div></div></div>");
};
buf.push("<form class=\"stacked-form\">");
jade_mixins["checkbox"].call({
block: function(){
buf.push("Receive Emails");
}
}, 'receive_emails');
buf.push("<div class=\"settings-email-preferences__subscriptions js-settings-email-preferences__subscriptions\">");
var disable = !user.get('receive_emails');
jade_mixins["checkbox"].call({
block: function(){
buf.push("What's on Artsy This Week");
}
}, 'receive_weekly_email', disable);
jade_mixins["checkbox"].call({
block: function(){
buf.push("Art World News");
}
}, 'receive_editorial_email', disable);
jade_mixins["checkbox"].call({
block: function(){
buf.push("Auctions");
}
}, 'receive_auction_email', disable);
jade_mixins["checkbox"].call({
block: function(){
buf.push("Personalized Art Recommendations");
}
}, 'receive_personalized_email', disable);
jade_mixins["checkbox"].call({
block: function(){
buf.push("Artsy Specialist Recommendations");
}
}, 'receive_offer_emails', disable);
buf.push("</div><button class=\"avant-garde-button-white\">Save Changes</button></form>");
}
}, 'email-preferences', 'Email Preferences');
buf.push("<div class=\"settings-section\"><div class=\"settings-section__main\"><a href=\"/user/delete\" class=\"settings-disable-link garamond-button-text\">Delete Account</a></div></div>");}.call(this,"sd" in locals_for_with?locals_for_with.sd:typeof sd!=="undefined"?sd:undefined,"services" in locals_for_with?locals_for_with.services:typeof services!=="undefined"?services:undefined,"stitch" in locals_for_with?locals_for_with.stitch:typeof stitch!=="undefined"?stitch:undefined,"user" in locals_for_with?locals_for_with.user:typeof user!=="undefined"?user:undefined));;return buf.join("");
};
module.exports = template;